import React from "react";
import { useTranslation } from "react-i18next";
import { IOrderOperationDuration } from "../../../models/order/response";
import { getOperationDurationParts } from "../../../utils/helpers/order-operation-timings";
import styles from "./style.module.scss";

interface IProps {
  className?: string;
  duration?: IOrderOperationDuration | null;
  fallback?: React.ReactNode;
  seconds?: number | null;
}

const OrderOperationDuration: React.FC<IProps> = ({
  className,
  duration,
  fallback = "-",
  seconds,
}) => {
  const { i18n, t } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const getUnitLabel = (
    key: "day" | "hour" | "minute" | "second",
    value: number,
  ) => t(`operation_duration_${key}_${value === 1 ? "one" : "other"}`);
  const parts = getOperationDurationParts(duration, seconds, {
    dayLabel: t("operation_duration_day_one"),
    hourLabel: t("operation_duration_hour_one"),
    minuteLabel: t("operation_duration_minute_one"),
    secondLabel: t("operation_duration_second_one"),
  });

  if (!parts) return <>{fallback}</>;

  return (
    <span
      className={[
        styles.durationText,
        isRtl ? styles.rtl : styles.ltr,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      dir={isRtl ? "rtl" : "ltr"}
    >
      {parts.map((part) => (
        <span
          className={styles.durationPart}
          dir={isRtl ? "rtl" : "ltr"}
          key={part.key}
        >
          <span className={styles.durationValue}>{part.value}</span>
          <span>{getUnitLabel(part.key, part.value)}</span>
        </span>
      ))}
    </span>
  );
};

export default OrderOperationDuration;
